import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgFbLogo48WhiteBg = props => _jsxs("svg", _objectSpread(_objectSpread({
  width: 48,
  height: 48,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [_jsx("mask", {
    id: "fb-logo-48-white-bg_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M.003.002H48v47.706H.003V.002Z",
      fill: "#fff"
    })
  }), _jsx("g", {
    mask: "url(#fb-logo-48-white-bg_svg__a)",
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M48 24C48 10.745 37.255 0 24 0S0 10.745 0 24c0 11.98 8.776 21.908 20.25 23.708v-16.77h-6.094V24h6.094v-5.288c0-6.014 3.583-9.337 9.065-9.337 2.626 0 5.372.469 5.372.469v5.906h-3.026c-2.981 0-3.911 1.85-3.911 3.748V24h6.656l-1.064 6.938H27.75v16.77C39.224 45.908 48 35.98 48 24Z",
      fill: "#fff"
    })
  }), _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.342 30.938 34.406 24H27.75v-4.502c0-1.898.93-3.748 3.911-3.748h3.026V9.844s-2.746-.469-5.372-.469c-5.482 0-9.065 3.322-9.065 9.337V24h-6.094v6.938h6.094v16.77a24.17 24.17 0 0 0 7.5 0v-16.77h5.592Z",
    fill: props.color || "#58595B"
  })]
}));
export default SvgFbLogo48WhiteBg;